import { utilisationReports } from "@/analytics/utilisationReports";
import type { UtilisationFilters } from "@/analytics/types";
import { UtilisationApiDataTable } from "@/components/UtilisationApiDataTable";

type UtilisationTablesPanelProps = {
  filters: UtilisationFilters;
};

export function UtilisationTablesPanel({ filters }: UtilisationTablesPanelProps) {
  return (
    <section className="space-y-3">
      <h2 className="text-base font-semibold text-foreground">Utilisation Tables</h2>

      {utilisationReports.map((report) => (
        <UtilisationApiDataTable
          key={report.id}
          title={report.title}
          endpoint={report.endpoint}
          filters={filters}
          normalizer={report.normalizer}
          variant={report.variant}
          sortable={report.sortable}
          emptyMessage="No records found"
        />
      ))}
    </section>
  );
}
